/**
 * Clears legacy inline margin-top hacks on body / #MainContent (e.g. stock header index scripts).
 * ODX overlay header must not push or gap the main column.
 */
(function () {
  'use strict';

  function clearHeaderDrivenFlowGap() {
    var main = document.getElementById('MainContent');
    if (main && main.style && main.style.marginTop) main.style.marginTop = '';
    if (document.body && document.body.style && document.body.style.marginTop) {
      document.body.style.marginTop = '';
    }
  }

  clearHeaderDrivenFlowGap();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearHeaderDrivenFlowGap);
  }
  window.addEventListener('load', clearHeaderDrivenFlowGap);
})();
